import React from "react";

import { MsalProvider } from "@azure/msal-react";
import {
  AuthenticationResult,
  Configuration,
  EventType,
  IPublicClientApplication,
  PopupRequest,
  PublicClientApplication,
  RedirectRequest,
} from "@azure/msal-browser";

const baseUri = `${window.location.origin}/${
  process.env.REACT_APP_BASENAME ? `${process.env.REACT_APP_BASENAME}/` : ""
}`;

// MSAL configuration
const configuration: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID ?? "",
    authority: process.env.REACT_APP_AZURE_AUTHORITY,
    knownAuthorities: process.env.REACT_APP_AZURE_KNOWN_AUTHORITIES?.split(","),
    redirectUri: baseUri,
    postLogoutRedirectUri: baseUri,
    navigateToLoginRequestUrl: true,
  },
};

export const pca = new PublicClientApplication(configuration);

pca.addEventCallback((event) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS &&
    (event.payload as AuthenticationResult)?.account
  ) {
    const account = (event.payload as AuthenticationResult).account;
    pca.setActiveAccount(account);
  }
});

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: process.env.REACT_APP_AZURE_SCOPES?.split(",") ?? [],
};

export const forgotPasswordRequest: RedirectRequest = {
  scopes: [],
  authority: process.env.REACT_APP_AZURE_FORGOT_PASSWORD_AUTHORITY,
};

const AzureProvider = ({
  children,
  instance: _instance,
}: {
  children: React.ReactNode;
  instance?: IPublicClientApplication;
}): React.ReactElement => {
  const [instance] = React.useState(_instance ?? pca);
  return <MsalProvider instance={instance ?? pca}>{children}</MsalProvider>;
};

export default AzureProvider;
